module.exports = __webpack_public_path__ + "static/media/methodproof_screenshot.8a0c3d7e.webp";